<nav class="payroll-nav" [class.hidden]="isHidden" aria-label="Payroll navigation">
  <div class="nav-shell">
    <div class="nav-scroll">
      <ul class="nav-segment" role="tablist">
        <li role="presentation">
          <a #navLink routerLink="/settings/payroll/payroll-sync" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" role="tab">
            Payroll Sync
          </a>
        </li>
        <li role="presentation">
          <a #navLink routerLink="/settings/payroll/unapproved-timesheets" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" role="tab">
            Unapproved Timesheets
          </a>
        </li>
        <li role="presentation">
          <a #navLink routerLink="/settings/payroll/payroll-sync-history" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" role="tab">
            Payroll Sync History
          </a>
        </li>
          <li role="presentation">
          <a #navLink routerLink="/settings/payroll/payable-hours-history" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" role="tab">
            Payable Hours History
          </a>
        </li>
        <li role="presentation">
          <a #navLink routerLink="/settings/payroll/booked-hours-history" routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }" role="tab">
            Booked Hours History
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>